import { clientBase } from "../common";

export const get_notes_mounted_course = (_mounted_course_id) => {
  return clientBase(`v2/notes/${_mounted_course_id}`, "GET");
};

export const post_notes_course = (_body) => {
  return clientBase(`v2/notes`, "POST", {
    body: _body,
  });
};

export const edit_notes_course = (_body) => {
  return clientBase(`v2/notes/${_body.id}`, "PUT", {
    body: _body,
  });
};

export const delete_notes_course = (_note_id) => {
  return clientBase(`v2/notes/${_note_id}`, "DELETE");
};
